/* eslint-disable camelcase */
import React from 'react';
import { cancelButton, save, Text } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import vars from '../../theme/vars';
import AddRule1 from './Add1';
import RulesListForDealerNoti from './ListForDealerNoti';
import RulesListForDealerNotiDealer from './ListForDealerNotiDealer';

import ViewRule from './View';
import { IconButton } from '../../app-components/buttons/Buttons';
import { addIcon, back_Icon, editDealerLogo } from '../../images';

const { headings } = vars;

export default {
  [ROUTES.notiAdd.name]: {
    screen: AddRule1,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Add Customer Detail</Text>,
    headerActions: [cancelButton, save],
  },

  // [ROUTES.avRulesView.name]: {
  //   screen: ViewRule,
  //   screenProps: {
  //     editable: false,
  //     type: 'standard',
  //     visible: false,
  //     fromView: true,
  //   },
  //   expanded: true,
  //   title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Rule Details</Text>,
  //   headerActions: [
  //     // cancelButton,
  //     {
  //       render: (props) => (
  //         <IconButton
  //           description="Back"
  //           tooltipId="go-back"
  //           icon={back_Icon}
  //           style={{ usingIcon: true }}
  //           iconStyle={{ height: 20, width: 20 }}
  //           stylelg={{ paddingLeft: 0, paddingRight: 0 }}
  //           imageStyle={{ width: 35, height: 35 }}
  //           onClick={() => {
  //             props.eventDispatcher.notify('AVRulesListReload');
  //             props.navigation.pop();
  //           }}
  //         />
  //       ),
  //     },
  //     {
  //       render: () => (
  //         <IconButton
  //           description="Edit Rule"
  //           tooltipId="edit-rule"
  //           icon={editDealerLogo}
  //           style={{ usingIcon: true }}
  //           iconStyle={{ height: 20, width: 20 }}
  //           stylelg={{ paddingLeft: 0, paddingRight: 0 }}
  //         />
  //       ),
  //       type: 'link',
  //       link: (props) => ({
  //         view: ROUTES.avRuleEdit.name,
  //         params: {
  //           item: { ...props?.navigation?.state?.params.item },
  //         },
  //       }),
  //     },
  //   ],
  // },

  // [ROUTES.avRuleEdit.name]: {
  //   screen: EditRule,
  //   expanded: true,
  //   title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Edit Rule</Text>,
  //   headerActions: [cancelButton, save],
  // },

  // [ROUTES.avRulesListSA.name]: {
  //   screen: RulesList,
  //   expanded: true,
  //   title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>All Rules</Text>,
  //   headerActions: [
  //     {
  //       render: () => <Text> </Text>,
  //     },
  //   ],
  // },

  [ROUTES.NotificationUnsubDealer.name]: {
    screen: RulesListForDealerNotiDealer,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Notification Subscribe & Unsubscribe</Text>,
    headerActions: [
      {
        render: () => (
          <IconButton
            icon={addIcon}
            description="Unsubscribe Notification"
            tooltipId="unsub-noti"
            label="Unsub Noti"
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
          />
        ),
        type: 'link',
        link: {
          view: ROUTES.notiAdd.name,
          push: true,
          expanded: true,
        },
      },
    ],
  },
  
  [ROUTES.NotificationUnsub.name]: {
    screen: RulesListForDealerNoti,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Notification Subscribe & Unsubscribe</Text>,
    headerActions: [
      {
        render: () => (
          <IconButton
            icon={addIcon}
            description="Unsubscribe Notification"
            tooltipId="unsub-noti"
            label="Unsub Noti"
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
          />
        ),
        type: 'link',
        link: {
          view: ROUTES.notiAdd.name,
          push: true,
          expanded: true,
        },
      },
    ],
  },
};
